<template>
  <div class="Dropzone">
    <div ref="dropzone" id="dropzone" class="Dropzone__area"/>
    <div class="Dropzone__choices" v-if="slugIsIn(['defi1:1', 'defi1:2'])"> 
      <Choice id="0" type="text"/>
      <Choice id="1" type="text"/>
      <Choice id="2" type="text"/>
    </div>
    <div class="Dropzone__choices image" v-if="slugIsIn(['defi2:1', 'defi2:2', 'defi2:3'])"> 
      <ChoiceImage/>
    </div>
  </div>
</template>
<script>
import Choice from './Choice'
import ChoiceImage from './ChoiceImage'
export default {
  name: 'Dropzone',
  components: { Choice, ChoiceImage },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Dropzone

  &__area
    width 460px
    height 500px
    border 2px solid white
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    background rgba(black, .9)
    opacity 0
    pointer-events none

    +max-screen-height(tablet-portrait)
      height 50%

  &__choices 
    height 50px
    position absolute
    top calc(50% + 200px)
    left 50%
    transform translate(-50%, -50%)
    display flex 
    align-items center
    justify-content center
    padding 0 25px
    min-width 680px

    +max-screen-height(tablet-portrait)
      top 70%

    &.image 
      height 110px
      justify-content center

</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Dropzone.vue